import { http } from './http';


export async function listChpoOrdersToSquads(params = {}) {
    const { data } = await http.get('chpo/orders-to-squads/', { params });
    return data;
}

export async function getChpoOrderToSquad(id) {
    const { data } = await http.get(`chpo/orders-to-squads/${id}/`);
    return data;
}

export async function createChpoOrderToSquad(payload) {
    const { data } = await http.post('chpo/orders-to-squads/', payload);
    return data;
}

export async function updateChpoOrderToSquad(id, payload) {
    const { data } = await http.patch(`chpo/orders-to-squads/${id}/`, payload);
    return data;
}

export async function deleteChpoOrderToSquad(id) {
    const { data } = await http.delete(`chpo/orders-to-squads/${id}/`);
    return data;
}
